import { html, render } from "https://esm.sh/lit-html@3.3.1"
import "https://esm.sh/adorable-css@1.6.2"

render(html`
<div class="
    hbox(center)
    h(100%)
    bg(linear-gradient(in/oklab/180deg,#000003,#443653))
">
    <img
        class="h(200)"
        src="static/logo_250523.svg"
    />
</div>
`, document.body)
